<template>
  <div class="small-padding d-flex flex-column col-md-6 col-xxs-12 mt-2 mb-2 align-items-stretch mx-0 align-items-center">
    <article class="user-review-card bg-white p-3 rounded card-shadow">
      <section class="d-flex flex-xs-row flex-xxs-column justify-content-between">
        <div class="d-flex">
          <img height="64" src="@/assets/icons/avatar.svg" class="rounded">
          <div class="vue-star d-flex flex-column align-items-stretch mx-3">
            <h6 class>
              <strong>{{ review.nickname }}</strong>
            </h6>
            <StarRating
            :name="'starRate'+review.nickname" 
            :read-only="true"
            :round-start-rating="true"
            :rating="review.rate"
            :show-rating="false" 
            :star-size="20" 
            :border-width="0"
            class="star-rate d-flex align-items-center mb-2"/>
          </div>
        </div>
        <div class="date">
          {{ review.date }}
        </div>
      </section>
      <section class="mt-3">
        <p>
          {{ review.description }}
        </p>
      </section>
    </article>
  </div>
</template>

<script>
import VueStars from '@/components/VueStars.vue'
import StarRating from 'vue-star-rating'

export default {
  name: 'UserReviewCard',
  components: { VueStars, StarRating },
  props: {
    review: Object
  }
}
</script>
